import { GuestDataWrapper } from "./styles";
import { Grid } from "@mui/material";
import { HeaderSection } from "../reservationInfo/styles";
import { useTranslation } from "react-i18next";
import Input from "@Common/input";
import { PhoneNumberField } from "@Common/PhoneNumberField";
import { FORM_REGEX_VALIDATORS, isValidPhone } from "@utils";
import UserOctagonIcon from "@assets/svg/UserOctagonIcon.svg?react";
import { PhoneInputWrapper } from "./styles";
import { Controller, useFormContext } from "react-hook-form";

export default function GuestData() {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <GuestDataWrapper>
      <div>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <HeaderSection>
              <UserOctagonIcon />
              <p>{t("MANUALRESERVATION.GUESTDATA")}</p>
            </HeaderSection>
          </Grid>
          <Grid item xs={12} md={6}>
            <Input
              name="guestName"
              label={t("MANUALRESERVATION.FIRSTNameOfTheGuest")}
              placeholder={t("MANUALRESERVATION.FIRSTNameOfTheGuest")}
              registerOptions={{
                required: {
                  value: true,
                  message: t("MANUALRESERVATION.PLEASEENTERTHEGUESTSFIRSTNAME"),
                },
                pattern: {
                  value: FORM_REGEX_VALIDATORS.textOnly,
                  message: t("MANUALRESERVATION.ACCEPTTEXTONLY"),
                },
              }}
            />
          </Grid>
          <Grid item xs={12} />
          <Grid item xs={12} md={6}>
            <PhoneInputWrapper>
              <Controller
                name="guestPhoneNumber"
                control={control}
                rules={{
                  required: t(
                    "MANUALRESERVATION.PLEASEENTERTHEGUESTSMOBILENUMBER"
                  ),
                  validate: (v) =>
                    isValidPhone(v) ||
                    t("MANUALRESERVATION.PLEASEENTERTHEGUESTSMOBILENUMBERCORRECTLY"),
                }}
                render={({
                  field: { value, onChange, onBlur },
                  fieldState: { error },
                }) => (
                  <PhoneNumberField
                    value={value}
                    onChange={onChange}
                    onBlur={onBlur}
                    required
                    label={t("MANUALRESERVATION.GUESTMOBILENUMBER")}
                    placeholder={t("MANUALRESERVATION.GUESTMOBILENUMBER")}
                    error={error?.message ? t(error.message) : undefined}
                  />
                )}
              />
            </PhoneInputWrapper>
          </Grid>
        </Grid>
      </div>
    </GuestDataWrapper>
  );
}
